export const distance = (p0, p1) => {
  var x = p0.x - p1.x
  var y = p0.y - p1.y
  return Math.sqrt(x * x + y * y)
}